<template>
  <div class="auth-reset">
    <div class="auth-reset__logo">
      <img src="@/assets/img/auth-logo.svg" alt="Altezza Travel">
    </div>
    <h1 class="auth-reset__title">{{ $t('auth.forgotTitle') }}</h1>
    <p class="auth-reset__description">
      {{ $t('auth.forgotDescription') }}
    </p>
    <form v-if="!sent" class="auth-reset__form" @submit.prevent="submit">
      <app-form-group :label="$t('auth.email')" label-for="reset-email">
        <app-input
          id="reset-email"
          v-model.trim="email"
          type="email"
          autocomplete="email"
          placeholder="name@example.com"
        />
      </app-form-group>
      <app-button ref="submit" type="submit" :disabled="!isValidEmail">
        {{ $t('auth.sendInstructions') }}
      </app-button>
    </form>
    <p v-else class="auth-reset__result">{{ result }}</p>
    <router-link class="auth-reset__back" :to="{name: 'login'}">
      {{ $t('auth.backToLogin') }}
    </router-link>
  </div>
</template>

<script>
import {requestPersonalCabinetPasswordReset} from '@/http'

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      result: '',
      sent: false,
    }
  },
  computed: {
    isValidEmail() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)
    },
  },
  methods: {
    submit() {
      if (!this.isValidEmail) return
      this.$refs.submit.preload = true
      requestPersonalCabinetPasswordReset({email: this.email})
        .then(() => {
          this.result = this.$t('auth.neutralResult')
          this.sent = true
        })
        .finally(() => {
          if (this.$refs.submit) this.$refs.submit.preload = false
        })
    },
  },
}
</script>

<style lang="sass" scoped>
.auth-reset
  display: flex
  flex-direction: column
  align-items: center
  width: 100%

.auth-reset__logo
  margin-bottom: 54px
  line-height: 0

.auth-reset__title
  margin-bottom: 12px
  font-size: 28px

.auth-reset__description, .auth-reset__result
  max-width: 320px
  margin-bottom: 28px
  color: #666
  font-size: 14px
  line-height: 1.5
  text-align: center

.auth-reset__form
  display: flex
  flex-direction: column
  align-items: center
  width: 100%
  max-width: 300px

  .form-group
    width: 100%

.auth-reset__back
  margin-top: 24px
  color: $color-theme
  font-size: 13px
</style>
